import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  toggle: {
    id: 'course-authoring.sidebar.toggle-button',
    defaultMessage: 'Toggle',
    description: 'Toggle button alt',
  },
  backBtnText: {
    id: 'course-authoring.sidebar.back.btn.alt-text',
    defaultMessage: 'Back',
    description: 'Alternate text for Back button in sidebar title',
  },
  itemMenuAlt: {
    id: 'course-authoring.sidebar.item-menu.button.alt',
    defaultMessage: 'Item Menu',
    description: 'Alternate text for Item Menu in the sidebar',
  },
  menuDuplicate: {
    id: 'course-authoring.sidebar.item-menu.duplicate',
    defaultMessage: 'Duplicate',
    description: 'Text for the Duplicate button in the sidebar menu',
  },
  menuCopy: {
    id: 'course-authoring.sidebar.item-menu.copy',
    defaultMessage: 'Copy to Clipboard',
    description: 'Text for the Copy button in the sidebar menu',
  },
  menuMoveUp: {
    id: 'course-authoring.sidebar.item-menu.move-up',
    defaultMessage: 'Move Up',
    description: 'Text for the Move Up button in the sidebar menu',
  },
  menuMoveDown: {
    id: 'course-authoring.sidebar.item-menu.move-down',
    defaultMessage: 'Move Down',
    description: 'Text for the Move Down button in the sidebar menu',
  },
  menuUnlink: {
    id: 'course-authoring.sidebar.item-menu.unlink',
    defaultMessage: 'Unlink from Library',
    description: 'Text for the Unlink button in the sidebar menu',
  },
  menuDelete: {
    id: 'course-authoring.sidebar.item-menu.delete',
    defaultMessage: 'Delete',
    description: 'Text for the Delete button in the sidebar menu',
  },
  menuUnlinkDisabledTooltip: {
    id: 'course-authoring.sidebar.item-menu.unlink.tooltip',
    defaultMessage: 'Only the highest level library reference can be unlinked.',
    description: 'Tooltip for disabled unlink option',
  },
  menuViewLibrary: {
    id: 'course-authoring.sidebar.item-menu.view-library',
    defaultMessage: 'View in Library',
    description: 'Text for the View in Library button in the sidebar menu',
  },
  menuCopyLocation: {
    id: 'course-authoring.sidebar.item-menu.copy-location',
    defaultMessage: 'Copy Location ID',
    description: 'Text for the Copy location button in the sidebar menu',
  },
  menuMove: {
    id: 'course-authoring.sidebar.item-menu.move',
    defaultMessage: 'Move',
    description: 'Text for the Move button in the sidebar menu',
  },
});

export default messages;
